(function() {
    orig = $.fn.css;
    $.fn.css = function() {
        var result = orig.apply(this, arguments);
        $(this).trigger('stylechanged');
        return result;
    }
})();

$(window).scroll(function(){
  if($(window).scrollTop() >= 25){
      $("#HeaderWrapper").addClass("scroll");
  } else {
      $("#HeaderWrapper").removeClass("scroll");
  }



});

$( document ).ready(function() {
var children =  $('.slick-track').children('.slick-slide').length;
$('.slick-track').on('stylechanged', function () {
var style =  $(this).attr('style').split('translate3d')[1].replace(/\(|\)/g, '').split(',')[1];
//console.log(style);
});
});